import type { HybridDropConfig } from '#lib/features/live-drop-info/types.js';

type AdditionalOption = {
	item?: ({ __typename?: string } & HybridDropConfig) | null;
} | null;

// The Hybrid_Config among a drop config's additional options, or null for a
// drop that is not hybrid.
export const getHybridDropConfig = (
	additionalOptions: AdditionalOption[] | null | undefined
): HybridDropConfig | null => {
	const option = (additionalOptions ?? []).find(
		(additionalOption) => additionalOption?.item?.__typename === 'Hybrid_Config'
	);

	return option?.item ?? null;
};
